import { render } from "./UdpView.vue?vue&type=template&id=ccbe5b0a"
import script from "./UdpView.vue?vue&type=script&lang=js"
export * from "./UdpView.vue?vue&type=script&lang=js"

import "./UdpView.vue?vue&type=style&index=0&id=ccbe5b0a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__